<template>
  <footer>
    <div class="foot">
      <div class="mylogo"></div>
      <div class="content">
        <div class="item">
          <h4>公司地址</h4>
          <p>北京市朝阳区东三环北路38号院1号</p>
          <p>泰康金融大厦3616</p>
        </div>
        <div class="item">
          <h4>联系我们</h4>
          <p>
            商务合作：<a href="mailto:business@atlascap.com.cn"
              >business@atlascap.com.cn</a
            >
          </p>
          <p>
            递送商业计划书：<a href="mailto:bp@atlascap.com.cn"
              >bp@atlascap.com.cn</a
            >
          </p>
          <p>
            人才招纳：<a href="mailto:hr@atlascap.com.cn">hr@atlascap.com.cn</a>
          </p>

          <p>联系电话：010-65081864</p>
        </div>

        <div class="logo">
          <img :src="logo" alt="" />
        </div>
      </div>
    </div>
    <p class="bottom">
      Copyright © 2020 Atlas. All Rights Reserved. 浙ICP备17036572号
    </p>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      logo: require("../assets/headlogo.jpg")
    };
  },
  computed: {
    ...mapGetters({ language: "getType" })
  }
};
</script>

<style lang="less" scoped>
footer {
  a {
    text-decoration: none;
    color: #fff;
  }
  width: 100%;
  padding-top: 50px;
  background: #ff8f3c;
  background-image: url("../assets/footbg.png");
  background-position: bottom right;
  background-repeat: no-repeat;
  background-size: 160px 300px;
  position: relative;
  margin-top: 60px;
  .mylogo {
    position: absolute;
    left: 20px;
    top: 0px;
    width: 209px;
    height: 60px;
    background: url("../assets/footlogo.png") no-repeat;
    background-size: contain;
  }
  .foot {
    width: 1200px;
    margin: 0 auto;
    height: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    display: flex;
    box-sizing: border-box;
    padding-bottom: 80px;
    justify-content: space-between;
    align-items: flex-end;
    position: relative;
  }
  .content {
    width: 800px;
    height: 100%;
    display: flex;
    margin-left: 400px;
    justify-content: space-between;
    .item {
      flex: 1;
      h4 {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
        margin-bottom: 20px;
      }
      p {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }
    .logo {
      width: 129px;
      height: 129px;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .bottom {
    position: absolute;
    bottom: 16px;
    left: 50%;
    transform: translateX(-50%);
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
    opacity: 0.48;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue